import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MultiSelectDropdownComponent} from './multi-select-dropdown.component';
import {IconsModule} from '../../icons/icons.module';
import {SharedModule} from '../../shared/shared.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';

@NgModule({
  declarations: [
    MultiSelectDropdownComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    MatMenuModule,
    MatSelectModule
  ],
  exports: [
    MultiSelectDropdownComponent
  ]
})
export class MultiSelectDropdownModule { }
